import { render, staticRenderFns } from "./LoadChartComponent.vue?vue&type=template&id=c68a2116&"
import script from "./LoadChartComponent.vue?vue&type=script&lang=js&"
export * from "./LoadChartComponent.vue?vue&type=script&lang=js&"
import style0 from "./LoadChartComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports